import { pagesPath } from "@/utils/$path";

export const isOauthCallbackPage = (pathname: string): boolean => {
  return (
    pathname === pagesPath.zoom.callback.$url().pathname ||
    pathname === pagesPath.zoom_phone.callback.$url().pathname ||
    pathname === pagesPath.zoom_admin.callback.$url().pathname ||
    pathname === pagesPath.google_calendar.callback.$url().pathname ||
    pathname === pagesPath.outlook_calendar.callback.$url().pathname ||
    pathname === pagesPath.microsoft.callback.$url().pathname ||
    pathname === pagesPath.salesforce.callback.$url().pathname ||
    pathname === pagesPath.career_plus.callback.$url().pathname
  );
};
